(function () {
  function getOrdinalSuffix(day) {
    if (day > 3 && day < 21) {
      return 'th';
    }

    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }

  function pushWeekendToMonday(date) {
    while (date.getDay() === 0 || date.getDay() === 6) {
      date.setDate(date.getDate() + 1);
    }
    return date;
  }

  function calculateDeliveryDate(daysToAdd) {
    var offset = Number(daysToAdd);
    if (!Number.isFinite(offset)) {
      offset = 0;
    }

    var date = new Date();
    date.setHours(12, 0, 0, 0);
    date.setDate(date.getDate() + offset);

    return pushWeekendToMonday(date);
  }

  function formatDeliveryDate(date) {
    var month = date.toLocaleString(undefined, { month: 'short' });
    var day = date.getDate();
    return month + ' ' + day + getOrdinalSuffix(day);
  }

  function initDeliveryTime(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var components = context.querySelectorAll('[data-delivery-time]');

    components.forEach(function (component) {
      if (component.dataset.deliveryStyle !== 'dates') {
        return;
      }

      var showEndDateOnly = component.dataset.showEndDateOnly === 'true';
      var toDate = calculateDeliveryDate(component.dataset.toDay);
      var toDateElement = component.querySelector('[data-delivery-to]');

      if (toDateElement) {
        toDateElement.textContent = formatDeliveryDate(toDate);
      }

      if (showEndDateOnly) {
        return;
      }

      var fromDate = calculateDeliveryDate(component.dataset.fromDay);
      var fromDateElement = component.querySelector('[data-delivery-from]');

      if (fromDateElement) {
        fromDateElement.textContent = formatDeliveryDate(fromDate);
      }
    });
  }

  function onSectionEvent(event) {
    if (!event || !event.target) {
      initDeliveryTime(document);
      return;
    }
    initDeliveryTime(event.target);
  }

  window.initSkyrocketDeliveryTime = initDeliveryTime;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initDeliveryTime(document);
    });
  } else {
    initDeliveryTime(document);
  }

  document.addEventListener('shopify:section:load', onSectionEvent);
  document.addEventListener('shopify:section:select', onSectionEvent);
  document.addEventListener('shopify:block:select', onSectionEvent);
})();
